<template>
  <div class="ibox float-e-margins">
    <user-header></user-header>
    <user-content></user-content>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from './User/Header'
import Content from './User/Content'

export default {
  computed: {
    ...mapGetters({
      users: 'getUsers'
    })
  },
  components: {
    userHeader: Header,
    userContent: Content
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/User.vue